module.exports = __webpack_public_path__ + "img/weixin.352426df.png";